/**
 * Sets the background of the app to a specified mode.
 * Acceptable modes are ONLY: purple | blue.
 * Default mode is mission.
 * @param {string} mode - The mode to set the background to. (purple or blue)
 */
export function setLayoutBackgroundTo(mode = 'purple') {
  document.documentElement.setAttribute('data-theme', `${mode}-layout`);
}
